module.exports = __webpack_public_path__ + "static/img/r_023.917bfc0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic/r_023.jpg
// module id = kver
// module chunks = 1